/**
 * 网络请求配置
 */
import axios from 'axios';

/**
 * http request 拦截器
 */
axios.interceptors.request.use(
  (config) => {
    config.headers = {
      'Content-Type': 'application/json',
      // "Authorization": "Basic c3dvcmQ6c3dvcmRfc2VjcmV0",
      ...config.head,
    };
    // 请求体封装
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * http response 拦截器
 */

axios.interceptors.response.use(
  (response) => {
    return Promise.resolve(response);
  },
  (error) => {
    if (error.response) {
      // 错误码处理
      switch (error.response.status) {
        // 500:
        case 500:
          return Promise.reject(error.response);
        // 其他错误，直接抛出错误提示
        default:
          console.error(error.response.data.msg);
      }
    } else {
      return Promise.reject('网络异常');
    }
  }
);
axios.defaults.timeout = 60000;
/**
 * 封装get方法
 * @param url  请求url
 * @param params  请求参数
 * @param head  header参数
 * @returns {Promise}
 */
export function get(url, params = {}, head = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
        head: head,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @param head  header参数
 * @returns {Promise}
 */

export function post(url, data, head = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data, { head }).then(
      (response) => {
        if (response) {
          resolve(response.data);
        } else {
          resolve();
        }
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
